/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {IApplicationFeatures} from '@ion/core/src/security/ApplicationFeatures';
import {GenericObject} from '@ion/core/src/types/entities';
import {defaultModuleActions} from '@ion/dls/src/editors/features/helpers';
import {createModuleActions, MODULES} from '@ion/dls/src/editors/features/ModuleActionHelpers';
import Features from './Features';

/**
 * ExtendedModules, which is having more then default actions.
 * Reference to feature use.
 */
const ExtendedModules = [
  MODULES.DEVICES
];

/**
 * Define the modules method which is creating the default Actions for the
 * all available modules.
 */
export const modules = (moduleName: string, api: GenericObject): GenericObject => {
  const actions = [...defaultModuleActions];
  return createModuleActions({
    Features,
    moduleName,
    actions,
    api
  });
};

/**
 * The generateAllModuleActions provides the single point of entry for generate the feature module actions
 * and  associate with feature id to future purpose.
 *
 * Generally, the `generateAllModuleActions` method should only be used directly to generate
 * the feature modules (via the Features.getFeatureModules) method.
 *
 * While the lower-level `EntityObserver` APIs can be used directly, the convention
 * is to implement higher-level entity specific APIs.
 *
 * ```typescript
 *   import generateAllModuleActions from '@/security/FeatureModules';
 *   import {modules} from '@/security/FeatureModules';
 *
 * [ADMIN_ACCOUNTS]: [{
 *    id      : 'Account-Create-1',
 *    name    : 'Create',
 *    enabled : false
 *  }]
 * ```
 *
 */
export const generateAllModuleActions = (api: IApplicationFeatures) => {
  return Object.entries(MODULES).map(([key, value]) => {
    return {[key]: modules(value, api)};
  });
};
